declare global {
  interface Window {
    REACT_APP_API_URL?: string;
  }
}

export interface LiveFeedEventRes {
  events: LiveFeedEvent[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface LiveFeedEvent {
  eventId: number;
  logoUrl: string;
  venueName: string;
  dateFrom: string;
  dateTo: string;
  eventName: string;
  eventDate: string;
  active: boolean;
  toDatePassed: boolean;
  activeDatePassed: boolean;
  turnOffAfterToDatePassed: boolean;
  autoRefreshResultsFeedTime: string;
  eventClassList: LiveFeedEventClass[];
  eventDateGroup: string;
  discipline: Disciplines;
  status: string;
  evStatus: EventType;
  resultsDocUrl?: string;
  scoreByOptimumTime?: boolean;
  publishResultsLiveFeed: boolean;
  publishTimesLiveFeed: boolean;
  timeStamp: string;
  timeStampUrl: string | null;
  timesDocUrl?: string;
  isOnlineEntry: boolean;
  showSJFullResults: boolean;
}

export type EventType = 'affiliated' | 'unaffiliated' | 'mixed';

export enum Disciplines {
  ArenaCourseHire = 'Arena/CourseHire', //
  TrainingClinics = 'Training Clinics',
  Dressage = 'Dressage', //
  Showjumping = 'Showjumping', //
  MixedEvents = 'Mixed Events',
  Shows = 'Shows',
  CombinedTraining = 'Combined Training', //
  EventerTrial = 'Eventer Trial', //
  XCCourseHire = 'XC Course Hire',
  HunterTrials = 'Hunter Trials',
  BoxOffice = 'Box Office',
}

export interface LiveFeedEventClass {
  id: number;
  eventId: number;
  description: string | null;
  createdDate: string;
  modifiedDate: string;
  arenaName: string;
  clNumber: number | null;
  clSort: string;
  classDay: string | null;
  numberOfEntries: number;
  liveEventFeedStatusText: 'Open' | 'Closed';
  startTime: string;
  endTime: string;
  className: string;
  className1: string;
  className2: string;
  judges?: string;
  numberOfJudges?: number;
  judgeNamesPositions?: JudgeNamePosition[];
  judgePositions?: string;
  classId: number;
  sjPhasesCount: number;
  linkAvailable: boolean;
  youngHorseResultsRule: boolean;
}

export interface JudgeNamePosition {
  name: string;
  position: string;
}

export interface LiveFeedEventSponsor {
  url: string;
  imageUrl: string;
  name: string;
}

export interface LiveFeedEventNews {
  createdDate: string;
  description: string;
  eventId: number;
  eventNewsItemId: number;
  modifiedDate: string;
}

export interface LiveFeedEventTime {
  breakTimeCustom?: string;
  breakTimeName?: string;
  bridleNumber?: number;
  cappedClassNotes: string;
  class: string;
  classId: number;
  customHorseName: string;
  drawnOrder: number;
  dressageTime?: string;
  showJumpingTime?: string;
  eaClassEntrySectionName: string;
  eaEventClassAndSort: string;
  evclid: number;
  eventId: number;
  riderClassStatusName: string;
  riderClassStatusCode: string;
  riderFullName: string;
  secretaryEventId: number;
  secretaryID: number;
  ownerFullName: string;
}

export interface LiveFeedEventResult {
  breakTimeCustom: string;
  breakTimeName?: string;
  bridleNumber: number;
  bsjaHorseName?: string;
  bsjaRegistrationNumber?: string;
  class: string;
  classId: number;
  dressageTime?: string;
  showJumpingTime?: string;
  isCBScoreBE?: boolean;
  eaEventClassAndSort: string;
  evclid: string;
  eventId: string;
  horseName?: string;
  customHorseName?: string;
  horseNameFormatted?: string;
  ownerBSJARegNumber?: string;
  ownerFirstName?: string;
  ownerLastName?: string;
  ownerNameFormatted?: string;
  riderBSJARegNumber?: string;
  riderClassStatusName: string;
  riderClassStatusCode: string;
  riderFirstName: string;
  riderLastName: string;
  riderNameFormatted: string;
  secretaryEventId: number;
  secretaryID: number;
  sectionName: string;
  sjPlace?: number;
  overallPlace?: number;
  sectionPlace?: number;
  selectedResult?: number;
  dressageScore?: number;
  dressageCollective?: number;
  eaDressagePercentageCustom?: number;
  judgeScores?: number[];
  sjPenalties?: number;
  sjFaults?: number;
  totalJFaults?: number;
  xcFaults?: number;
  isScoringEntered?: boolean;
  evTrialScoringTime?: number;
  evTrialTimePenalties?: number;
  evTrialTotalScore?: number;
  evTrialTotalScoreByOptTime?: number;
  totalCBScore?: number;
  totalCBScoreBE?: number;
  htJumpPenalties?: number;
  htTimePenalties?: number;
  htTimeTaken?: string;
  htTotalScore?: number;
  [key: `phase${number}JF`]: number | undefined;
  [key: `phase${number}TF`]: number | undefined;
  [key: `phase${number}F`]: number | undefined;
  [key: `phase${number}RecTime`]: number | undefined;
  orderLiveResultsByPlacing?: boolean;
}

export interface Sort {
  order: 'asc' | 'desc';
  field: string;
}
